class CartTable extends HTMLElement {
  constructor() {
    super();
    this.isUpdating = false;

    this.boundHandleRemoveClick = this.handleRemoveClick.bind(this);
    this.boundHandleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.boundHandleRemoveClick);
    this.addEventListener("change", this.boundHandleCheckboxChange);
    this.updateCheckoutButton();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.boundHandleRemoveClick);
    this.removeEventListener("change", this.boundHandleCheckboxChange);
  }

  async handleRemoveClick(event) {
    const removeButton = event.target.closest("[data-remove-item]");
    if (!removeButton) return;

    event.preventDefault();

    if (this.isUpdating) return;

    this.isUpdating = true;
    this.dataset.cartUpdating = "true";

    const removeUrl = removeButton.href;

    try {
      const response = await fetch(removeUrl, {
        method: "GET",
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await this.updateSection();

      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
        }),
      );
    } catch (error) {
      console.error("Error removing item:", error);
      window.location.reload();
    } finally {
      this.isUpdating = false;
      this.dataset.cartUpdating = "false";
    }
  }

  handleCheckboxChange(event) {
    if (event.target.id === "terms-and-conditions") {
      this.updateCheckoutButton();
    }
  }

  updateCheckoutButton() {
    const checkbox = this.querySelector("#terms-and-conditions");
    const checkoutButton = this.querySelector('input[name="checkout"]');

    if (checkbox && checkoutButton) {
      checkoutButton.disabled = !checkbox.checked;
    }
  }

  async updateSection() {
    try {
      const url = new URL(window.location);
      url.searchParams.set("section_id", "cart");

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartTable = doc.querySelector("cart-table");

      if (newCartTable) {
        this.innerHTML = newCartTable.innerHTML;
        this.dataset.cartCount = newCartTable.dataset.cartCount;

        this.updateCheckoutButton();
      }
    } catch (error) {
      console.error("Error updating cart section:", error);
      throw error;
    }
  }
}

customElements.define("cart-table", CartTable);
